(function () {
	let swiperMulticolumn;
	const multicolumnSwipeEnabled = document.querySelector(
		".swiper--multicolumn",
	);

	const addClasses = () => {
		const slides = document.querySelectorAll(".swiper--multicolumn .multicolumn-list__item");
		slides.forEach((slide) => {
			slide.classList.add("swiper-slide");
		});
	};

	const initSlider = () => {
		swiperMulticolumn = new Swiper(".swiper--multicolumn", {
      loop: false,
      breakpoints: {
        320: {
          slidesPerView: 1,
          slidesPerGroup: 1,
          spaceBetween: 0,
        },
        640: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          spaceBetween: 24,
        },
      },
      simulateTouch: true,
      allowTouchMove: true,
      watchSlidesProgress: true,
      preventInteractionOnTransition: true,
      mousewheel: {
        forceToAxis: true,
      },
      pagination: {
        el: ".multicolumn__pagination",
        type: "fraction",
      },
      navigation: {
        nextEl: ".multicolumn__button-next",
        prevEl: ".multicolumn__button-prev",
      },
    });
	};

	const destroySlider = () => {
		const slides = document.querySelectorAll(".multicolumn-list__item");

		if (Array.isArray(swiperMulticolumn)) {
			swiperMulticolumn.forEach((swiper) => {
				swiper.destroy(true, true);
			});
		} else {
			swiperMulticolumn.destroy(true, true);
		}
		swiperMulticolumn = null;

		slides.forEach((slide) => {
			slide.removeAttribute("style");
			slide.classList.remove("swiper-slide");
		});
	};

	const initMulticolumn = () => {
		const multicolumnSection = document.querySelector(".multicolumn-section");

		const sectionResizeObserver = new ResizeObserver((entries) => {
			const [entry] = entries;

			if (entry.contentRect.width < 991 && multicolumnSwipeEnabled) {
				addClasses();
				initSlider();
			} else if (swiperMulticolumn) {
				destroySlider();
			}
		});

		sectionResizeObserver.observe(multicolumnSection);
	};

	if (swiperMulticolumn) {
		destroySlider();
	}
	addClasses();
	initMulticolumn();
	initSlider();
	document.addEventListener("shopify:section:load", function () {
		if (swiperMulticolumn) {
			destroySlider();
		}
		addClasses();
		initMulticolumn();
		initSlider();
	});
})();
/* ==========================================
   AFFICHAGE GARANTI DE LA BARRE FLOTTANTE
   ========================================== */

(function () {
  function initStickyProductBars() {
    const bars = document.querySelectorAll(
      "floated-form.floated-form"
    );

    if (!bars.length) return;

    bars.forEach(function (bar) {
      if (bar.dataset.stickyVisibilityReady === "true") return;

      const section = bar.closest(
        'section[id^="MainProduct-"]'
      );

      if (!section) return;

      bar.dataset.stickyVisibilityReady = "true";

      function findOriginalButton() {
        return Array.from(
          section.querySelectorAll(
            ".product-form__submit"
          )
        ).find(function (button) {
          return !button.closest("floated-form");
        });
      }

      function updateBarVisibility() {
        const originalButton = findOriginalButton();

        let shouldShow = window.scrollY > 500;

        if (originalButton) {
          const rect = originalButton.getBoundingClientRect();

          shouldShow = rect.bottom < 0;
        }

        bar.classList.toggle(
          "mp-floated-visible",
          shouldShow
        );

        bar.setAttribute(
          "aria-hidden",
          shouldShow ? "false" : "true"
        );
      }

      window.addEventListener(
        "scroll",
        updateBarVisibility,
        { passive: true }
      );

      window.addEventListener(
        "resize",
        updateBarVisibility
      );

      window.addEventListener(
        "orientationchange",
        updateBarVisibility
      );

      updateBarVisibility();
    });
  }

  function observeStickyProductBars() {
    initStickyProductBars();

    const observer = new MutationObserver(function () {
      initStickyProductBars();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    window.setTimeout(initStickyProductBars, 300);
    window.setTimeout(initStickyProductBars, 800);
    window.setTimeout(initStickyProductBars, 1500);
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      observeStickyProductBars
    );
  } else {
    observeStickyProductBars();
  }
})();